import { getPayablePoolTokens } from '@ui/constants/tokens';
import { useDataChainId } from '@ui/hooks/datachain';
import { checkIsDesktopUp, useBreakpoint } from '@ui/hooks/useBreakPoint';
import { PayablePoolToken } from '@ui/types/token';
import { useMemo } from 'react';

import { PickerDrawer } from './PickerDrawer';
import { PickerMenu } from './PickerMenu';
import { CollateralTokenPickerBaseProps } from './type';

export const CollateralTokenPicker = ({
  onSelect,
  children,
  title,
  overridePayableTokens,
}: CollateralTokenPickerBaseProps & {
  overridePayableTokens?: PayablePoolToken[];
}) => {
  const { value: isDesktopAndUp } = useBreakpoint(checkIsDesktopUp);
  const chainId = useDataChainId();
  const payableTokens = useMemo(() => {
    return overridePayableTokens ?? getPayablePoolTokens(chainId);
  }, [chainId]);

  if (isDesktopAndUp) {
    return (
      <PickerMenu
        payableTokens={payableTokens}
        onSelect={onSelect}
        title={title}
      >
        {children}
      </PickerMenu>
    );
  }

  return (
    <PickerDrawer
      payableTokens={payableTokens}
      onSelect={onSelect}
      title={title}
    >
      {children}
    </PickerDrawer>
  );
};
